/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum LogicModuleType {
    COUNTERGOAL = 'COUNTER_GOAL',
    COUNTERPEREVENT = 'COUNTER_PER_EVENT',
    STREAKEVENT = 'STREAK_EVENT',
    STREAKTIME = 'STREAK_TIME',
    NULLIFIER = 'NULLIFIER'
}

export function LogicModuleTypeFromJSON(json: any): LogicModuleType {
    return LogicModuleTypeFromJSONTyped(json, false);
}

export function LogicModuleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogicModuleType {
    return json as LogicModuleType;
}

export function LogicModuleTypeToJSON(value?: LogicModuleType | null): any {
    return value as any;
}

